$(function() {

var body = $('body');

var delayHeight,
winH = document.documentElement.clientHeight,
winW = document.documentElement.clientWidth;

function elFunc(){
	let mm = gsap.matchMedia();
	document.querySelectorAll('.el').forEach((_tar, i) => {
		let _elmc = _tar.querySelectorAll('.elc');
		let _y = 0;
		if( _elmc.length == 0 ){
			_elmc = _tar;
			_y = _elmc.classList.contains('nomove') ? 0 : 60;
		}else{
			_elmc.forEach((_el, i) => {
				_y = _el.classList.contains('nomove') ? 0 : 60;
			});
		}

		gsap.set(_elmc,{ opacity:0, y:_y });
		gsap.to(_elmc,
			{ opacity:1, y:0, 
				duration: 1.2,
				delay: 0.2,
				ease: "power4.out",
 				stagger: 0.1,
				scrollTrigger: {
					trigger: _tar,
					start: "top bottom-=10%",
					onRefresh: self => self.progress === 1 && self.animation.progress(1)
				}
			}
		);
	});

	const up_scrollTrigger = ScrollTrigger.create({
		trigger: body,
		start: "top top",
		onUpdate: self => {
			const _slfscrl = self.scroll();
			if(self.direction == -1){
				document.body.classList.remove('scrldown');
			}else{
				if(_slfscrl > 10){
					if(self.prevSclrl < _slfscrl-1){
						document.body.classList.add('scrldown');
					}
					self.prevSclrl = _slfscrl;
				}
			}
			scrltop (_slfscrl);
		},
	});
	body.addClass('scrltop');
}
const scrltop = (_slfscrl) => {
	if(_slfscrl > 10){
		body.removeClass('scrltop');
		body.addClass('scrl');
	}else{
		body.removeClass('scrl');
		body.addClass('scrltop');
	}
}

async function ScrollSmootherKill() {
	await new Promise((resolve, reject) => {
		ScrollTrigger.killAll();
		resolve();
	})
}


// Nav show/hide
function nav_show(){
	body.addClass('navopen');
}
function nav_hide(){
	body.removeClass('navopen');
}
function navInit(){
	$('#nav_btn').on('click', function(){
		if(body.hasClass('navopen')){
			nav_hide();
		}else{
			nav_show();
		}
	});
	$('.hassub_btn').on('click', function(e){
		e.preventDefault();
		const _parent = $(this).parent();
		if(_parent.hasClass('active')){
			gsap.to(_parent.find('.subnav'), { duration:0.3, height:0, ease:'power1'});
		}else{
			gsap.to(_parent.find('.subnav'), { duration:0.3, height:"auto", ease:'power1'});
		}
		_parent.toggleClass('active');
	});
}

function anchorscrl(){
	let tar_offset = 0;
	let navelm = document.getElementById('nav');
	if(navelm !== null){
		tar_offset = navelm.clientHeight;
	}
	if(window.matchMedia('(max-width:767px)').matches){
		tar_offset = 0;
	}
	$('a.anchor').on('click', function(){
		nav_hide();
		let href = this.hash;
		gsap.to(window, { duration:0.6, scrollTo:{y:href, autoKill:true, offsetY:tar_offset}, ease:'power2'});

		var hrefPageUrl = $(this).prop("href");
		hrefPageUrl = hrefPageUrl.split("#")[0];
		var currentUrl = location.href;
		currentUrl = currentUrl.split("#")[0];
		if( hrefPageUrl == currentUrl ){
			return false;
		}
	});
	$('#btt').on('click', function(){
		gsap.to(window, { duration:0.6, scrollTo:{y:0, autoKill:true}, ease:'power2'});
		return false;
	});
}


function shoulder_section(){
	document.querySelectorAll('.topsec').forEach((_tar, i) => {
		const sec_scrollTrigger = ScrollTrigger.create({
			trigger: _tar,
			start: "top center-=10%",
			end: "bottom center+=10%",
			onEnter: self => {
				_tar.classList.add('sec_active');
				console.log('onEnter');
			},
			onLeave: self => {
				_tar.classList.remove('sec_active');
			},
			onEnterBack: self => {
				_tar.classList.add('sec_active');
			},
			onLeaveBack: self => {
				_tar.classList.remove('sec_active');
			},
		});
	});
}


function topslider(){	
	$('.full_slider').each(function(){
		const swiper = new Swiper(this, {
			effect: 'fade',
			crossFade: true,
			slidesPerView: 1,
			speed: 600,
			spaceBetween: 10,
			loop: true,
			autoplay: {
				delay: 4000,
			},
			keyboard: {
				enabled: false,
			},
		});
	});

	$('.half_slider').each(function(){
		const swiper = new Swiper(this, {
			slidesPerView: 1,
			speed: 600,
			spaceBetween: 10,
			loop: true,
			autoplay: {
				delay: 4000,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
			}	
		});
	});
	$('#journal_list_slider').each(function(){
		const swiper = new Swiper(this, {
			slidesPerView: 2,
			speed: 600,
			spaceBetween: 10,
			loop: true,
			autoplay: {
				delay: 4000,
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
				},
			}	
		});
	});
}

function modalslider(){
	const swiper = new Swiper('#modal_slider', {
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		slidesPerView: 1,
		speed: 600,
		spaceBetween: 0,
		autoplay:false,
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-next',
			prevEl: '.swiper-prev',
		},
	});

	const _item = '#look_sec .item';
	$(_item).on('click', function(){
		const _index = $(this).index(_item);
		swiper.slideTo(_index, 0);
		body.addClass('modal');
	});
	$('#m_close').on('click', function(){
		body.removeClass('modal');
	});
}


function imgSlider(){
	$('.imgSlider').each(function(){
		const swiper = new Swiper(this, {
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			slidesPerView: 1,
			speed: 600,
			spaceBetween: 0,
			loop: true,
			autoplay: {
				delay: 2000,
			},
			keyboard: false,
			pagination: false,
			navigation: false,
			allowTouchMove: false,
		});
	});
}

function storeslider(){	
	const swiper = new Swiper('#store_slider', {
		slidesPerView: 1,
		speed: 600,
		spaceBetween: 10,
		loop: true,
		autoplay: {
			delay: 4000,
		},
		keyboard: {
			enabled: false,
		},
	});
}

function collectionslider(){
	$('#collection_slider').each(function(){
		const swiper = new Swiper(this, {
			slidesPerView: 1,
			speed: 600,
			spaceBetween: 10,
			loop: true,
			autoplay:false,
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			pagination: {
				el: '.swiper-pagination',
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	});
}

function recommend_slider(){
	var recommend_slider = new Swiper('#recommend_slider', {
		spaceBetween: 20,
		slidesPerView: 1.5,
		loop: false,
		loopedSlides: 5,
		threshold: 10,
		navigation: {
			nextEl: '.reco_next',
			prevEl: '.reco_prev',
		},
		pagination: {
			el: ".reco-pagination",
			type: "fraction",
		},
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		centeredSlides: true,
		breakpoints: {
			768: {
				slidesPerView: 3,
			},
			1200: {
				slidesPerView: 4,
			}
		}
	});
}
function dynamic_checkout(){
	setTimeout(function(){
		$('.shopify-payment-button__button--unbranded').text('Buy it now');
	},1000);
}
function contactFunc(){
$('.inpt_efct').keyup(function() {
	if( $(this).val() ) {
		$(this).addClass('has_content');
	} else {
		$(this).removeClass('has_content');
	}
});
}

function popup(){
	$('#popupclose').on('click', function(e){
		gsap.fromTo('#popup',{opacity:1},{
			autoAlpha:0,
			duration: 0.3,
			ease:'power1',
		});
	});

}

function img_parent(){
	const cont_img = document.querySelectorAll('.txt_block img');
	cont_img.forEach((target, i) => {
		target.outerHTML = '<div class="imgwrap el nomove">'+target.outerHTML+'</div>';
	});
}

function exLink(){
	var links = document.links;
	for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
		if (links[i].hostname !== window.location.hostname) {
			links[i].target = '_blank';
			links[i].rel = 'noreferrer noopener';
		}
	}
}

function storeFunc() {
	var list_btn = $('.list_btn');
	list_btn.on('click',function(){
		$(this).parent().toggleClass('active');
		$(this).next().slideToggle(300);
	});
}


// === Salon 23ku === //
function salon_slider(){
  //最後のswiper-slideを先頭に移動する
  const slider_wrapper = document.querySelector('#salon_slider .swiper-wrapper');
  slider_wrapper.insertBefore(slider_wrapper.lastElementChild, slider_wrapper.firstElementChild);

  const swiper = new Swiper('#salon_slider', {
    slidesPerView: 1,
    speed: 600,
    spaceBetween: 10,
    loop: true,
    // loopAdditionalSlides: 1,
    initialSlide: 1,
    watchSlidesProgress: true,
    autoplay: {
      delay: 4000,
    },
    keyboard: {
      enabled: false,
    },
		breakpoints: {
			768: {
				slidesPerView: 1,
			},
		}
  });
}
function salon_item_slider(){	
  const swiper = new Swiper('#salon_item_slider', {
    slidesPerView: 1,
    speed: 600,
    spaceBetween: 10,
    keyboard: {
      enabled: false,
    },
    navigation: {
			nextEl: '.item_next',
			prevEl: '.item_prev',
		},
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1000: {
        slidesPerView: 3,
      }
    }
  });
}
function salon_novelty_slider(){	
  const swiper = new Swiper('#salon_novelty_slider', {
    slidesPerView: 1,
    speed: 600,
    spaceBetween: 10,
    loop: true,
    keyboard: {
      enabled: false,
    },
    navigation: {
			nextEl: '.item_next',
			prevEl: '.item_prev',
		},
  });
}
function salon_news_slider(){	
  const swiper = new Swiper('#salon_news_slider', {
    slidesPerView: 1,
    speed: 600,
    spaceBetween: 10,
    keyboard: {
      enabled: false,
    },
    navigation: {
			nextEl: '.item_next',
			prevEl: '.item_prev',
		},
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1000: {
        slidesPerView: 3,
      }
    }
  });
}
function adobefont_load(){
  try {
    Typekit.load({
      loading: function() {
      },
      active: function() {
        body.addClass('adobefont_loaded');
      },
      inactive: function() {
      }
    })
  } catch(e) {}
}

function video_for_edge(){
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (!isSafari) {
    document.querySelectorAll('video').forEach(function (video) {
      video.querySelectorAll('source[type="application/x-mpegURL"]').forEach(function (s) {
        s.remove();
      });
      video.load();
      video.play().catch(function () {});
    });
  }
};

function initialize(){
	exLink();
	body.addClass('ready');
	anchorscrl();
	navInit();
	dynamic_checkout();
	elFunc();
  adobefont_load();
  video_for_edge();
}

window.addEventListener('load', function () {
	initialize();
});

if( document.getElementById('slider') ){
	imageSlide();
}
if( document.getElementById('modal_slider') ){
	modalslider();
	imgSlider();
}
if( document.getElementById('top') ){
	body.addClass('top');
	topslider();
	popup();
	shoulder_section();
}
if( document.getElementById('article') ){
	img_parent();
}
if( document.getElementById('store') ){
	storeFunc();
	storeslider();
}
if( document.getElementById('salon_top') ){
	salon_slider();
  salon_item_slider();
  salon_novelty_slider();
  salon_news_slider();
  shoulder_section();
}

});

